import { useEffect, useState } from "react";
import { BookmarkPlus, Bookmark, Trash2, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { toLibrary } from "@/lib/routeLibrary";
import { playerRoutes } from "@/lib/playEngine";

export function RouteLibrary({ play, player, onApply }) {
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [manage, setManage] = useState(false);
  useEffect(() => { api.get("/route-library").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const hasRoute = playerRoutes(play, player.id).length > 0;

  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/route-library", { name: name.trim(), segments: toLibrary(play, player) });
      setItems([data, ...(items || [])]); setName(""); setSaving(false);
      toast.success(`"${data.name}" saved to My Routes`);
    } catch (ex) { toast.error(errMsg(ex)); }
  };
  const remove = async (it) => {
    try { await api.delete(`/route-library/${it.id}`); setItems(items.filter((x) => x.id !== it.id)); toast.success("Route removed from your library"); } catch (ex) { toast.error(errMsg(ex)); }
  };

  return (
    <div className="space-y-2" data-testid="route-library">
      <div className="flex items-center justify-between gap-2">
        <p className="label mb-0 flex items-center gap-1"><Bookmark size={14} />My Routes (all your plays)</p>
        {items?.length > 0 && <button className="text-xs font-bold text-slate-400 hover:text-white flex items-center gap-1 min-h-[32px]" onClick={() => setManage(!manage)} data-testid="btn-manage-library"><Settings2 size={14} />{manage ? "Done" : "Manage"}</button>}
      </div>
      {items === null ? <p className="text-xs text-slate-500">Loading…</p> : !items.length ? (
        <p className="text-xs text-slate-500" data-testid="library-empty">No saved routes yet. Draw a route, then tap "Save to My Routes".</p>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          {items.map((it) => manage ? (
            <button key={it.id} className="chip border-red-500/50 text-red-300" onClick={() => remove(it)} data-testid={`library-delete-${it.id}`}><Trash2 size={14} />{it.name}</button>
          ) : (
            <button key={it.id} className="chip" onClick={() => onApply(it)} data-testid={`library-apply-${it.id}`}>{it.name}</button>
          ))}
        </div>
      )}
      {hasRoute && (saving ? (
        <form onSubmit={save} className="flex gap-2" data-testid="library-save-form">
          <input className="input" autoFocus maxLength={40} placeholder="Name, e.g. Double move" value={name} onChange={(e) => setName(e.target.value)} data-testid="library-name-input" />
          <button className="btn btn-primary" disabled={!name.trim()} data-testid="library-save-submit">Save</button>
          <button type="button" className="btn btn-ghost" onClick={() => setSaving(false)} data-testid="library-save-cancel">Cancel</button>
        </form>
      ) : (
        <button className="btn btn-ghost" onClick={() => setSaving(true)} data-testid="btn-save-to-library"><BookmarkPlus size={16} />Save {player.label}'s route to My Routes</button>
      ))}
    </div>
  );
}
